<template>
  <div class="tab-content">
    <ul class="tab-content__ul">
      <router-link :class="{ 'disabled-link': onBuildingTypesPage }" :to="getLink(listItem)" v-for="listItem in tabData" :key="listItem.id">
        <li class="tab-content__ul__li" :class="{ 'no-rank': !listItem.rankTotal }">
          <span v-if="listItem.rankTotal" class="tab-content__ul__li__order">{{
            tab === 1 && listItem.rankTotal ? listItem.rankTotal.plats : tab === 2 && listItem.rankKvm ? listItem.rankKvm.plats : '&nbsp;'
          }}</span>
          <span v-else></span>
          <div class="tab-content__ul_li__data">
            <span class="tab-content__ul__li__data__first">{{ title(listItem) }}</span>
            <span>{{ firstData(listItem) }}</span
            ><br />
            <span v-if="onProjectsPage">{{ round(listItem.bruttoarea) }} m²</span>
            <p v-if="onProjectsPage && listItem.egenKommentar !== ''" class="ownComment">{{ formattedOwnComments(listItem.egenKommentar) }}<br /></p>
            <!--   <p v-if="!onProjectsPage && listItem.egnaKommentarer !== ''" class="ownComment">
              <span v-for="(comment, index) in formattedOwnComments(listItem.egnaKommentarer)" :key="index">{{ comment }}</span
              ><br />
            </p> -->
          </div>
          <div class="amount-unit-container">
            <span class="tab-content__ul__li__amount">{{ round(tab === 1 ? listItem.totalaUtslapp / 1000 : listItem.utslappKvm) }}&nbsp;</span>
            <span class="tab-content__ul__li__unit">{{ tab === 1 ? 'ton' : 'kg' }} CO₂e</span>
          </div>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    tab: {
      type: Number,
      required: true,
    },
  },
  computed: {
    title() {
      return (listItem) =>
        this.onCommunesPage
          ? listItem.kommun
          : this.onBuildersPage
          ? listItem.byggherre
          : this.onProjectsPage && listItem.fastighetsbeteckning
          ? this.formatFastighetsbeteckning(listItem.fastighetsbeteckning)
          : this.onBuildingTypesPage
          ? listItem.byggnadsTypString
          : 'listItem.id';
    },
    formatBuilderTitle() {
      return (byggherre) => (byggherre.includes('Byggherre -') ? byggherre.split('Byggherre -')[1] : byggherre);
    },
    firstData() {
      return (listItem) => (this.onProjectsPage ? this.formatKommun(listItem.kommun) : 'BTA: ' + listItem.bruttoarea + ' m²');
    },
    tabData() {
      return this.tab === 1 ? this.sortedTotal : this.sortedKvm;
    },
    sortedKvm() {
      let sortedData = [...this.data].sort((a, b) => b.utslappKvm - a.utslappKvm);
      return sortedData;
    },
    sortedTotal() {
      let sortedData = [...this.data].sort((a, b) => b.totalaUtslapp - a.totalaUtslapp);
      return sortedData;
    },
    onCommunesPage() {
      return this.$route.name === 'communes';
    },
    onBuildersPage() {
      return this.$route.name === 'builders';
    },
    onProjectsPage() {
      return this.$route.name === 'projects';
    },
    onBuildingTypesPage() {
      return this.$route.name === 'building-types';
    },
    round() {
      return (number) => {
        return Math.round(number);
      };
    },
    formattedOwnComments() {
      return (comments) => {
        let formattedComments = [];
        let lang = localStorage.getItem('selectedLanguage') === 'sv' ? 0 : 1;

        //Om det bara finns en kommentar vilket kommer vara fallet om man är på projektsidan
        if (typeof comments === 'string') return comments.split('*')[lang];

        comments.forEach((comment) => {
          const langs = comment.split('*');
          formattedComments.push(langs[lang]);
        });
        return formattedComments;
      };
    },
  },
  methods: {
    formatFastighetsbeteckning(fastighetsbeteckning) {
      const parts = fastighetsbeteckning.split(',');
      const formattedFirstPart = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
      return formattedFirstPart;
    },
    formatKommun(kommun) {
      const parts = kommun.split(',');
      const formattedFirstPart = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
      return formattedFirstPart;
    },
    getLink(listItem) {
      let link;
      let query;
      if (this.tab === 1) {
        query = 'total';
      } else {
        query = 'kvm';
      }
      if (this.onCommunesPage) {
        link = '/communes/' + listItem.kommun;
      } else if (this.onBuildersPage) {
        link = '/builders/' + listItem.byggherre;
      } else if (this.onProjectsPage) {
        link = '/projects/' + listItem.id;
      } else {
        link = '/building-types/' + '#';
      }
      return link + '?rankQuery=' + query;
    },
    firstLetterToUppercase(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style scoped>
.tab-content {
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.tab-content__ul {
  padding: 0;
  margin: 0;
}
.tab-content__ul a {
  text-decoration: none;
  cursor: pointer;
}
.tab-content__ul__li {
  display: grid;
  grid-template-columns: 60px auto 110px;
  gap: 10px;
  padding: 4px;
  text-align: left;
  border-bottom: 1px solid rgb(153, 153, 153);
  padding: 15px;
}
.no-rank {
  margin-left: -60px;
}
.tab-content__ul__li:active {
  background-color: #2637f3;
  color: white;
}

.tab-content__ul__li:hover span,
.tab-content__ul__li:hover p {
  color: white;
}
.tab-content__ul__li:hover {
  background-color: #2637f3;
}
.tab-content__ul__li span {
  color: black;
}
.tab-content__ul__li__order,
.tab-content__ul__li__data__first,
.tab-content__ul__li__amount {
  font-family: 'fet', sans-serif;
  line-height: 1.2em;
  display: block;
}
.tab-content__ul__li__order {
  margin-left: 10px;
}
.tab-content__ul__li__data__first {
  word-break: break-word;
}

.tab-content__ul_li__data {
  line-height: 1.2em;
  max-width: 500px;
}
.amount-unit-container span {
  font-family: 'fet', sans-serif;
  line-height: 1.2em;
}

.disabled-link {
  pointer-events: none;
  cursor: default;
}

.ownComment {
  display: block;
  margin-top: 1em;
  margin-bottom: 0;
}

.ownComment,
.ownComment span {
  color: black;
  font-size: 14px;
}

@media all and (min-width: 500px) {
  .tab-content {
    border-top: 0;
  }
}
@media all and (max-width: 499px) {
  .tab-content__ul__li span {
    margin-right: 0px;
  }
}
@media all and (min-width: 1050px) {
  .tab-content__ul__li__order {
    margin-left: 20px;
  }
  .amount-unit-container span {
    display: inline;
  }
  .tab-content__ul__li {
    grid-template-columns: 60px auto 180px;
  }
}
</style>
